import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import FormDivider from "../../../FormDivider/formDivider";
import GoogleButton from "../../../googleButton";
import Input from "../../../Input/input";
import PasswordInput from "../../../Input/passwordInput";

import { closeModal, showSignUpForm, toggleforgotPassword } from "../../../../redux/slices/formDetails";
import { updateIsLoggedIn } from "../../../../redux/slices/user";
import { getUserDetails, loginUser } from "../../../../services/auth";
import { validateEmail } from "../utils";
import SuccessModal from "../../SuccessModal/SuccessModal";
import { useSelector } from "react-redux";

export default function Signin({ handleClose, signInError, setSignInError }) {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [rememberMe, setRememberMe] = useState(false);

  const changeForm = () => {
    dispatch(showSignUpForm(true));
  };

  const handleError = (err) => {
    if (err.data.detail === "Email is not registered!") {
      setEmailError("Email not registered");
    } else {
      setPasswordError("Invalid credentials.");
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setEmailError("");
    setPasswordError("");

    const result = validateEmail(email.trim());

    if (email === "" || password === "") {
      email === "" && setEmailError("This field cant be empty");
      password === "" && setPasswordError("This field cant be empty");
      return;
    }
    if (result === null) return setEmailError("Please enter your email address in format : xyz@gmail.com");

    const credentials = {
      email: email.trim(),
      password: password.trim(),
    };

    loginUser(credentials, (err, res) => {
      if (err) return handleError(err.response);
      if (res !== null) {
        // alert("logged in");
        handleClose();
        if (rememberMe) {
          localStorage.setItem("access", res.data.access);
          localStorage.setItem("refresh", res.data.refresh);
          localStorage.setItem("withGoogle", false);
        } else {
          localStorage.setItem("access", res.data.access);
          localStorage.setItem("refresh", res.data.refresh);
          localStorage.setItem("withGoogle", false);
        }
        dispatch(updateIsLoggedIn(true));
        getUserDetails((err, userDetails) => {
          if (err) return handleError(err.response);
          localStorage.setItem("userName", userDetails.data.name);
          localStorage.setItem("userEmail", userDetails.data.email);
          localStorage.setItem("userId", userDetails.data.id);
        });
      }
    });
  };

  const handleForgotPassword = () => {
    dispatch(closeModal());
    dispatch(toggleforgotPassword());
  };

  const pageVariants = {
    initial: { y: "-100vh" },
    in: { y: 0 },
    out: { y: "-100vw" },
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.6,
  };

  useEffect(() => {
    return () => {
      setSignInError("");
    };
  }, []);

  // console.log(rememberMe);

  return (
    <>
      <div className="form_modal__form sign-in-form">
        <div className="form_modal__header form_modal__signin-header">
          <div className="modal_back_btn icon-button" onClick={handleClose}>
            {`<`}
          </div>
          Sign in
        </div>
        {signInError !== "" && (
          <div className="error" style={{ textAlign: "center", color: "rgba(227, 0, 0, 1)", marginBottom: "1rem" }}>
            {signInError}
          </div>
        )}
        <GoogleButton text={"Sign in with Google"} />
        <FormDivider />
        <form onSubmit={handleLogin}>
          <div className="form_modal__form_fields">
            <Input placeholder="email" value={email} setValue={setEmail} errorMsg={emailError} />
            <PasswordInput placeholder="password" value={password} setValue={setPassword} errorMsg={passwordError} />
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center remember-me">
              <input defaultChecked={rememberMe} onChange={() => setRememberMe(!rememberMe)} id="remember_me" type="checkbox" />
              <label htmlFor="remember_me" className="text">
                Remember Me
              </label>
            </div>
            <div className="forgot-password" onClick={handleForgotPassword}>
              Forgot Password? <div className="text_underline"></div>
            </div>
          </div>
          <button className="form_modal__submit_btn btn-primary">Sign In</button>
        </form>
        <div className="form-footer">
          Not a member? &nbsp;
          <span className="form-link" onClick={changeForm}>
            <span className="text_underline"> </span>
            Create an account.
          </span>
        </div>
      </div>
    </>
  );
}
